module.exports = __webpack_public_path__ + "media/begg.e622842c.mp3";